// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  StyleWrapper,
  Header,
  ContactList,
  ToggleButton,
} from './touch.styled';
import type { Nav } from '../../../types/apiRoute';
import type { ContactSettings } from '../../../types/settings';
import getContactSettings from '../../../store/contactSettings/selectors';
import {
  getMyUrl,
  getMyLabel,
  getTouchMenuButtonText,
} from '../../../store/siteSettings/selectors';
import ElementGenerator from './elementGenerator';

type StateProps = {|
  contactSettings: ContactSettings,
  myUrl: string,
  myLabel: string,
  touchMenuButtonText: string,
|};

type OwnProps = {|
  nav: Nav,
|};

type Props = {|
  ...StateProps,
  ...OwnProps,
|};

class Touch extends Component<Props> {
  menu = null;

  componentDidMount() {
    this.addUiEvents();
  }

  getSubItems = (): Array<HTMLElement> => (this.menu ? [].slice.call(this.menu.querySelectorAll('li')) : []);

  reset = () => this.getSubItems().forEach(item => item.classList.remove('active'));

  toggleMenu = () => {
    this.reset();
    if (this.menu) {
      if (document.body !== null) {
        document.body.style.overflow = 'hidden';
      }
      this.menu.classList.toggle('toggled');
    }
  };

  addUiEvents = () => {
    const subItems = this.getSubItems();
    if (!subItems) {
      return;
    }
    subItems.forEach(item => {
      const anchorElement = item.querySelector('a');
      if (!anchorElement) {
        return;
      }
      if (item.classList.contains('has-children')) {
        anchorElement.addEventListener('click', () => {
          item.classList.add('active');
        });
        const backLinkElement = item.querySelector('.back-link');
        if (backLinkElement) {
          backLinkElement.addEventListener('click', () => item.classList.remove('active'));
        }
      } else if (!anchorElement.classList.contains('back-link')) {
        anchorElement.addEventListener('click', () => {
          this.toggleMenu();
          if (document.body !== null) {
            document.body.style.overflow = 'visible';
          }
        });
      }
    });
  };


  render() {
    const {
      nav,
      contactSettings: {
        general_number,
        general_email_address,
      },
      myUrl,
      myLabel,
      touchMenuButtonText,
    }: Props = this.props;
    return (
      <StyleWrapper>
        <Header>
          <ToggleButton
            role="button"
            tabIndex="0"
            onClick={this.toggleMenu}
          >
            <i className="icon-hamburger" />
            <span className="label">{touchMenuButtonText}</span>
          </ToggleButton>
        </Header>
        <nav id="menu" ref={navElement => { this.menu = navElement }}>
          <ElementGenerator
            nav={nav}
            isTouch
          />
          <ContactList>
            {general_number && (
              <li className="contact-item">
                <a className="contact-item-link" href={`tel:${general_number}`}>
                  <i className="icon-telephone" />
                  <span className="contact-item-label">
                    {general_number}
                  </span>
                </a>
              </li>
            )}
            {general_email_address && (
              <li className="contact-item">
                <a className="contact-item-link" href={`mailto:${general_email_address}`}>
                  <i className="icon-envelope" />
                  <span className="contact-item-label">
                    {general_email_address}
                  </span>
                </a>
              </li>
            )}
            {myUrl && (
              <li className="contact-item">
                <a className="contact-item-link" href={myUrl}>
                  <i className="icon-user" />
                  <span className="contact-item-label">
                    {myLabel}
                  </span>
                </a>
              </li>
            )}
          </ContactList>
        </nav>
      </StyleWrapper>
    );
  }
}

const mapStateToProps = (state): StateProps => ({
  contactSettings: getContactSettings(state),
  myUrl: getMyUrl(state),
  myLabel: getMyLabel(state),
  touchMenuButtonText: getTouchMenuButtonText(state),
});

export default connect<any, OwnProps, StateProps, any, any, any>(
  mapStateToProps,
)(Touch);
